import React, { useState } from 'react';

import './ContactLensHeaderTitle.scss';

export const ContactLensHeaderTitle = props => {
  const { baseImageUrl, data } = props;
  const { title, subTitle, description, bestOffer } = data;

  const [isRedHeart, setIsRedHeart] = useState(false);

  return (
    <div className="contact-lens-header-title__container">
      <h1 className="contact-lens-header-title__title">
        <strong>{title}</strong>
        <small>{subTitle}</small>
        <div
          className="contact-lens-header-title__icon-heart"
          onClick={() => setIsRedHeart(!isRedHeart)}
        >
          <img
            alt="Add To Shortlist"
            src={`${baseImageUrl}/icons/heart-${isRedHeart ? 'active' : 'inactive'}.svg`}
          />
        </div>
      </h1>

      <div className="contact-lens-header-title__price">
        <p className="contact-lens-header-title__price-desc">{description.title}</p>

        <div className="contact-lens-header-title__price-container">
          <div className="contact-lens-header-title__price-before">
            <span>{description.price.before}</span>
          </div>

          <div className="contact-lens-header-title__price-after">
            <span>{description.price.after}</span>
          </div>
        </div>
      </div>

      <div className="contact-lens-header-title__best-offer">
        <p className="contact-lens-header-title__best-offer-title">Best offer for you</p>
        <p className="contact-lens-header-title__best-offer-discount">
          Get {bestOffer.discount} off second pair
        </p>
      </div>
    </div>
  );
};
